// Static language mappings for Monaco Editor and execution
const codeConstants = {
  CPP: {
    value: 76,
    language: "cpp",
    name: "C++",
    defaultCodesnippet: `
#include <iostream>
#include <vector>
using namespace std;

class Main {
  public:
  vector<int> solution(vector<int>& nums, int target){
    cout<<"Hi There"<<endl;
    vector<int> result= {2,3};
    return result;
  }
};

int main() {
    Main m;
    vector<int> vals={1,2,3,4};
    int target=10;
    vector<int> result=m.solution(vals,target);
    for(int eachValue: result){
      cout<<eachValue<<endl;
    }
    return 0;
}`,
  },
  JAVA: {
    value: 62,
    language: "java",
    name: "Java",
    defaultCodesnippet: `
public class Main {
    public int[] solution(int[] nums, int target) {
        // Your code here
        System.out.println("Hi There");
        return new int[] {1,2};
    }
    
    public static void main(String[] args) {
        Main solution = new Main();
        int[] nums = {2, 7, 11, 15};
        int target = 9;
        int[] result = solution.solution(nums, target);
        System.out.println(result[0] + ", " + result[1]);
    }
}
      `,
  },
  JAVASCRIPT: {
    value: 93,
    language: "javascript",
    name: "JavaScript",
    defaultCodesnippet: `
    class Main {
  
      solution(nums,target) {
        console.log("Hi There");
        return [1,2];
      }
  
    }

    const solution = new Main();
    const nums = [2, 7, 11, 15];
    const target = 9;
    const result = solution.solution(nums, target);
    console.log(result[0] + ", " + result[1]);
      `,
  },
  PYTHON: {
    value: 109,
    language: "python",
    name: "Python",
    defaultCodesnippet: `
class Main:
  def solution(self,nums):
    print(nums);
    return 0;

m=Main();
m.solution([1, 2, -3, -4, -5,10]);`,
  },
};

export default codeConstants;
